import _ from 'lodash';
import React from 'react';

import AddBandModal from 'common/components/add-band-modal';

class AddArtistButton extends React.Component {
	render () {
		return (
			<div className="grid-x align-right">
				<div className="cell shrink">
					<AddBandModal
						adminMode
						disableAutoLogin
						clearStoreData
						iconClassName="fas fa-plus padding-right-1"
						buttonLabel="Add Artist"
						buttonClassName="button neo margin-bottom-0"
						modalContentLabel="Add Artist"
						modalClassName={{
							base: 'modal',
							afterOpen: 'modal-after-open',
							beforeClose: 'modal-before-close'
						}}
						modalOverlayClassName={{
							base: 'modal-overlay',
							afterOpen: 'modal-overlay-after-open',
							beforeClose: 'modal-overlay-before-close'
						}} />
				</div>
			</div>
		);
	}
}

export default AddArtistButton;
